import * as React from 'react';

type Props = {
  number: string,
};

// Romanian plates: county code (1-2 letters), 2-3 digits, 3 letters, e.g. B-04-YAA, CT-123-ABC
const ROMANIAN_PLATE = /^([A-Z]{1,2})[\s-]?(\d{2,3})[\s-]?([A-Z]{3})$/;

// Ring of 12 stars on the EU band, drawn as dots
const EuStars = (): JSX.Element => (
  <svg className="plate__stars" viewBox="0 0 20 20" aria-hidden="true">
    {Array.from({ length: 12 }, (_, i) => {
      const angle = (i / 12) * Math.PI * 2;
      return (
        <circle
          key={i}
          cx={10 + Math.cos(angle) * 7}
          cy={10 + Math.sin(angle) * 7}
          r={1.3}
        />
      );
    })}
  </svg>
);

const LicensePlate = ({ number }: Props): JSX.Element => {
  const normalized = number.trim().toUpperCase();
  const match = ROMANIAN_PLATE.exec(normalized);

  return (
    <div className="plate" role="img" aria-label={normalized}>
      {match && (
        <span className="plate__band">
          <EuStars />
          RO
        </span>
      )}
      <span className="plate__number">
        {match ? match.slice(1).join(' ') : normalized}
      </span>
    </div>
  );
};

export default LicensePlate;
